const PERMISSION_KEY= "company:gold_snapshot";
const PAGE_URL = {
    GOLD_SNAPSHOT_PAGE: "/admin/company/gold-snapshot"
}

export {PERMISSION_KEY, PAGE_URL}

